import React, { FC } from 'react';
import styled from '@emotion/styled';
import quotationMark from '../../../assets/images/qoutationMark.png';

interface Props {
  html: string;
}

const StyledBlogWrapper = styled.div`
  h1,
  h2,
  h3,
  h4 {
    width: 80%;
    font-weight: 800;
    line-height: 1;
    margin-bottom: 0.5rem;
  }

  h2 {
    font-size: 40px;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 32px;
  }

  h4 {
    font-size: 24px;
  }

  p {
    width: 80%;
    font-weight: 300;
    font-size: 18px;
    line-height: 28px;
    margin: 0 0 30px;
  }

  blockquote {
    width: 100%;
    color: #333333;
    background-color: #ffeee6;
    border-radius: 4px;
    margin: 48px 0 48px;
    padding: 54px 70px 32px 90px;

    p:first-child {
      &:before {
        content: '';
        background-image: url(${quotationMark});
        width: 32px;
        height: 32px;
        position: absolute;
        z-index: 10;
        top: -4px;
        left: -40px;
      }
    }
  }

  blockquote p {
    width: 100%;
    position: relative;
    font-weight: normal;
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 24px;
  }

  blockquote p:nth-child(2) {
    margin-bottom: 0;
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
  }

  blockquote p:nth-child(3) {
    margin-bottom: 0;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }

  a {
    color: #247ddc;
    text-decoration: none;
  }

  ul,
  ol {
    font-size: 16px;
    line-height: 30px;
    margin: 0 0 30px;
    padding-left: 1.5em;
  }

  p > iframe {
    display: block;
    margin: 0 auto;
  }

  img {
    width: 100%;
  }

  @media (min-width: 834px) {
    .block_quote_quoted {
      font-weight: bold;
      font-size: 12px;
      line-height: 16px;
      margin: 0;
      letter-spacing: 0.15em;
      text-transform: uppercase;
    }

    .block_quote_team {
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.15em;
      text-transform: uppercase;
      margin: 0;
    }
  }
  @media (max-width: 834px) {
    h1,
    h2,
    h3,
    h4 {
      width: 100%;
    }

    blockquote {
      padding: 30px 30px 30px 60px;
    }

    p {
      width: 100%;
      font-size: 16px;
      line-height: 24px;
    }

    blockquote p {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

const BlogPostParser: FC<Props> = ({ html }) => (
  <StyledBlogWrapper
    dangerouslySetInnerHTML={{
      __html: html,
    }}
  />
);

export default BlogPostParser;
